import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contact">
      <header>
      <h2>Contact</h2>
      <p>Thanks for visiting my portfolio.</p>
      <p>Let’s Build Something Impactful Together!</p>
      </header>
      <div className="contacts">
        <a href="mailto:wadekar.shalaka50@gmail.com" className="contact-button">
          <img src={emailIcon} alt="Email" />
          <span>EMAIL ME</span>
        </a>
        <a href="tel:+447741883742" className="contact-button">
          <img src={phoneIcon} alt="Phone No" />
          <span>CALL ME</span>
        </a>
      </div>
      <Form></Form>
    </Container>
  )
}